import {Observable}                                                          from 'rxjs';
import {
  ApDynGridColumnConfigBase
}                                                                            from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                            from '../../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynformsConfigFieldset
}                                                                            from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ITaskManagementPlanBookGridData, TaskManagementWizardOpenConfigType} from '../../../task-management.types';

export enum WizardStates {
  Leave = 'Leave_TaskMgmt', // user clicks 'cancel' button on Selection page
  Selection = 'Global__Selection', // first wizard page where user can select plannings
  Details = 'Global__Details', // second wizard page configuring the details
  Overview = 'Admin_Pages__Overview', // last wizard page showing summary
  Export = 'Export_Tasks' // user click 'export' button on Overview page
}

export interface WizardUiState {
  getGridColumnConfig(): Observable<ApDynGridColumnConfigBase[]>;

  getPagerConfig(breadCrumbsColumns: WizardStates[], displayType: TaskManagementWizardOpenConfigType): ApDynGridPagerConfigBase;

  getFieldsetConfig(data: Array<ITaskManagementPlanBookGridData>): ApDynformsConfigFieldset[];
}
